import * as fromListaLayers from '../../actions/AdmMapa/ListaLayers.actions';


export interface ListaLayersState {
    loaded: boolean;
    listaLayers: Map<string,number> | null;
    errorMessage: any | null;
}

export const initialState: ListaLayersState = {
    loaded: false,
    listaLayers: null,
    errorMessage: null
  };

export function ListaLayersReducer(state = initialState, action: fromListaLayers.ListaLayersAcciones): ListaLayersState {
    switch (action.type) {
        case fromListaLayers.ListaLayersActionTypes.LAYERS_SET:
            return {
                ...state,
                loaded: true,
                listaLayers: {...action.ListaLayers},
                errorMessage: null
            };
      default: {
        return state;
      }
  }
}
